// UpdatePaymentCard.jsx
import React, { useState, useEffect } from "react";
import { 
  FiDollarSign, 
  FiCreditCard, 
  FiCheck, 
  FiCalendar, 
  FiHash,
  FiClock,
  FiAlertCircle,
  FiEdit2
} from "react-icons/fi";
import { useDispatch } from "react-redux";
import { closeProductModal } from "../../../../redux/features/productModalSlice";
function UpdatePaymentCard({ data }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
const [formData, setFormData] = useState({
  payment_type: "partial", // full | partial

  payment_mode: "cash", // cash, upi, cheque...

  receive_amount: "",

  transaction_no: "",

  payment_date: new Date().toISOString().split("T")[0],

  remark: "",

  total_amount: Number(data?.total_amount || 0),

  paid_amount: Number(data?.paid_amount || 0),

  due_amount: Number(data?.due_amount || 0),
});
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let newValue = value;
    if (type === 'number') {
      newValue = parseFloat(value) || 0;
    }
    setFormData(prev => {
      const updated = { ...prev, [name]: newValue };
      
      if (name === 'paid_amount') {
        const due = Math.max(0, updated.total_amount - newValue);
        updated.due_amount = due;
      } 
      return updated;
    }); 
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };
  const validateForm = () => {
    const newErrors = {};  
    if (!formData.payment_status) {
      newErrors.payment_status = "Payment status is required";
    }  
    if (!formData.payment_type) {
      newErrors.payment_type = "Payment type is required";
    }  
    if (formData.payment_status === "paid" && !formData.transaction_no) {
      newErrors.transaction_no = "Transaction number is required for paid status";
    }
    
    if (formData.payment_status === "paid" && formData.paid_amount <= 0) {
      newErrors.paid_amount = "Paid amount must be greater than 0";
    }
    
    if (formData.payment_status === "paid" && formData.paid_amount < formData.total_amount) {
      newErrors.paid_amount = "Paid amount must equal total amount for full payment";
    }
    
    if (!formData.payment_date) {
      newErrors.payment_date = "Payment date is required";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      // Here you can call your API to update payment
      console.log("Updating payment:", formData);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Show success message
      alert("Payment updated successfully!");
      
      // Refresh data
      if (data?.refreshData) {
        data.refreshData();
      }
      
      // Close modal
      dispatch(closeProductModal());
      
    } catch (error) {
      alert(error.message || "Failed to update payment");
    } finally {
      setLoading(false);
    }
  };

  // Auto-set paid amount when status is 'paid'
  useEffect(() => {
    if (formData.payment_status === "paid") {
      setFormData(prev => ({
        ...prev,
        paid_amount: prev.total_amount,
        due_amount: 0
      }));
    } else if (formData.payment_status === "pending") {
      setFormData(prev => ({
        ...prev,
        paid_amount: 0,
        due_amount: prev.total_amount
      }));
    }
  }, [formData.payment_status, formData.total_amount]);

  const getStatusBadge = (status) => {
    const statusMap = {
      'paid': { color: 'success', icon: <FiCheck /> },
      'pending': { color: 'warning', icon: <FiClock /> },
      'partial': { color: 'info', icon: <FiAlertCircle /> },
      'overdue': { color: 'danger', icon: <FiAlertCircle /> }
    };
    return statusMap[status] || statusMap['pending'];
  };

  return (
    <>
   <div className="main_page ">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Update Payment</h4>

        <span className="badge bg-primary fs-6">
          {data?.invoice_no}
        </span>
      </div>

      <form onSubmit={handleSubmit} className="row g-2">
        <div className="col-md-6">
          <label>
            Payment Method <span className="text-danger">*</span>
          </label>
          <select
            className={`form-control ${
              errors.payment_type ? "is-invalid" : ""
            }`}
            name="payment_type"
            value={formData.payment_type}
            onChange={handleChange}
          >
            <option value="">Select Payment Method</option>
            <option value="cash">Cash</option>
            <option value="upi">UPI</option>
            <option value="bank_transfer">Bank Transfer</option>
            <option value="cheque">Cheque</option>
            <option value="credit">Credit</option>
          </select>

          {errors.payment_type && (
            <div className="invalid-feedback d-block">
              {errors.payment_type}
            </div>
          )}
        </div>

        {/* Payment Status */}

        <div className="col-md-6">
          <label>
            Payment Status <span className="text-danger">*</span>
          </label>

          <select
            className={`form-control ${
              errors.payment_status ? "is-invalid" : ""
            }`}
            name="payment_status"
            value={formData.payment_status}
            onChange={handleChange}
          >
            <option value="paid">Paid</option>
            <option value="partial">Partial</option>
            <option value="pending">Pending</option>
          </select>

          {errors.payment_status && (
            <div className="invalid-feedback d-block">
              {errors.payment_status}
            </div>
          )}
        </div>

        {/* Invoice */}

        <div className="col-md-6">
          <label>Invoice No</label>

          <input
            className="form-control"
            value={data?.invoice_no}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label>Total Amount</label>

          <input
            className="form-control"
            value={`₹ ${Number(formData.total_amount).toLocaleString()}`}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label>
            Paid Amount <span className="text-danger">*</span>
          </label>

          <input
            type="number"
            className={`form-control ${
              errors.paid_amount ? "is-invalid" : ""
            }`}
            name="paid_amount"
            value={formData.paid_amount}
            onChange={handleChange}
          />

          {errors.paid_amount && (
            <div className="invalid-feedback d-block">
              {errors.paid_amount}
            </div>
          )}
        </div>

        {/* Due */}

        <div className="col-md-6">
          <label>Due Amount</label>

          <input
            className="form-control"
            value={`₹ ${Number(formData.due_amount).toLocaleString()}`}
            readOnly
          />
        </div>

        {/* Transaction */}

        <div className="col-md-6">
          <label>Transaction No</label>

          <input
            className={`form-control ${
              errors.transaction_no ? "is-invalid" : ""
            }`}
            name="transaction_no"
            value={formData.transaction_no}
            onChange={handleChange}
            placeholder="Enter Transaction Number"
          />

          {errors.transaction_no && (
            <div className="invalid-feedback d-block">
              {errors.transaction_no}
            </div>
          )}
        </div>
        <div className="col-md-6">
          <label>Payment Date</label>
          <input
            type="date"
            className={`form-control ${
              errors.payment_date ? "is-invalid" : ""
            }`}
            name="payment_date"
            value={formData.payment_date}
            onChange={handleChange}
          />
          {errors.payment_date && (
            <div className="invalid-feedback d-block">
              {errors.payment_date}
            </div>
          )}
        </div>
        {/* Remark */}

        <div className="col-md-12">
          <label>Remark</label>

          <textarea
            rows={3}
            className="form-control"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            placeholder="Enter Remark"
          />
        </div>

        {/* Summary */}

        <div className="col-md-12">

          <div className="border rounded p-3 bg-light">

            <div className="row">

              <div className="col-md-4 text-center">
                <h6>Total Amount</h6>
                <h5 className="text-primary">
                  ₹ {Number(formData.total_amount).toLocaleString()}
                </h5>
              </div>

              <div className="col-md-4 text-center">
                <h6>Paid Amount</h6>
                <h5 className="text-success">
                  ₹ {Number(formData.paid_amount).toLocaleString()}
                </h5>
              </div>

              <div className="col-md-4 text-center">
                <h6>Due Amount</h6>
                <h5 className="text-danger">
                  ₹ {Number(formData.due_amount).toLocaleString()}
                </h5>
              </div>

            </div>

          </div>

        </div>

        <div className="col-12 text-end">

          <button
            type="button"
            className="btn btn-secondary me-2"
            onClick={() => dispatch(closeProductModal())}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="add-btn"
            disabled={loading}
          >
            {loading ? "Updating..." : "Update Payment"}
          </button>

        </div>

      </form>

    </div>
     
      
    </>
  );
}

export default UpdatePaymentCard;